import React from "react";
import "./ListingContent.scss";
import { RESOLUTION } from "app/pages/.shared/responsive/responsiveReducer";
import classNames from "classnames";
import { LISTING_ITEM_TYPES } from "app/constants";
import { ListingItemFull } from "app/pages/Listing/components/ListingItemFull";
import { ListingItemCard } from "app/pages/Listing/components/ListingItemCard";
import PropTypes from "prop-types";
import { merchShape, productShape } from "app/utils/propTypes";
import isEqual from "lodash/isEqual";

class ListingContent extends React.Component {
	shouldComponentUpdate(nextProps) {
		const {
			resolution,
			orderedListingItems,
			isAnyListingFilterActive,
			isListViewDisplay,
		} = this.props;
		const {
			resolution: nextResolution,
			orderedListingItems: nextOrderedListingItems,
			isAnyListingFilterActive: nextIsAnyListingFilterActive,
			isListViewDisplay: nextIsListViewDisplay,
		} = nextProps;

		if (!isEqual(nextOrderedListingItems, orderedListingItems)) {
			return true;
		}

		if (resolution !== nextResolution) {
			return true;
		}

		if (isAnyListingFilterActive !== nextIsAnyListingFilterActive) {
			return true;
		}

		if (isListViewDisplay !== nextIsListViewDisplay) {
			return true;
		}

		return false;
	}
	render() {
		const {
			resolution,
			orderedListingItems,
			isAnyListingFilterActive,
			isListViewDisplay,
		} = this.props;

		return (
			<div className="listing-content">
				<div className="listing-content__container">
					<div className="listing-content-grid">
						{isListViewDisplay &&
						(resolution === RESOLUTION.LARGE || resolution === RESOLUTION.XLARGE)
							? orderedListingItems.map((listingItem, index) => {
									const itemClass = classNames({
										"listing-content-grid__item": true,
										"listing-content-grid__item--merchandising-simple":
											listingItem.type === LISTING_ITEM_TYPES.MERCH_SIMPLE,
										"listing-content-grid__item--merchandising-caroussel":
											listingItem.type === LISTING_ITEM_TYPES.MERCH_CAROUSSEL,
									});

									const key =
										(listingItem.id &&
											`${listingItem.id}${listingItem.startAt}`) ||
										(listingItem.merchandising &&
											listingItem.merchandising.code);

									return !isAnyListingFilterActive ||
										(isAnyListingFilterActive &&
											listingItem.type === LISTING_ITEM_TYPES.PRODUCT) ? (
										<div key={key} className={itemClass}>
											<ListingItemFull
												product={listingItem}
												position={index}
											/>
										</div>
									) : (
										false
									);
							  })
							: orderedListingItems.map((listingItem, index) => {
									const itemClass = classNames({
										"listing-content-grid__item": true,
										"listing-content-grid__item--card": true,
										"listing-content-grid__item--merchandising-simple":
											listingItem.type === LISTING_ITEM_TYPES.MERCH_SIMPLE,
										"listing-content-grid__item--merchandising-caroussel":
											listingItem.type === LISTING_ITEM_TYPES.MERCH_CAROUSSEL,
									});

									const key =
										(listingItem.id &&
											`${listingItem.id}${listingItem.startAt}`) ||
										(listingItem.merchandising &&
											(listingItem.merchandising.code ||
												listingItem.merchandising[0].code));

									return !isAnyListingFilterActive ||
										(isAnyListingFilterActive &&
											listingItem.type === LISTING_ITEM_TYPES.PRODUCT) ? (
										<div key={key} className={itemClass}>
											<ListingItemCard
												product={listingItem}
												position={index}
											/>
										</div>
									) : (
										false
									);
							  })}
					</div>
				</div>
			</div>
		);
	}
}

ListingContent.propTypes = {
	resolution: PropTypes.string,
	orderedListingItems: PropTypes.arrayOf(PropTypes.oneOfType([merchShape, productShape])),
	isAnyListingFilterActive: PropTypes.bool,
	isListViewDisplay: PropTypes.bool,
};

export default ListingContent;
